import styled from "@emotion/styled";
import { getGelTokens } from "@tal-gel/theming";
import React from "react";
import CountUp from "react-countup";
import "./pie.css";
import { css, keyframes } from "@emotion/css";
import TransitionComponent from "../Transition";

const Pie = ({ value, color }) => {
  return (
    <TransitionComponent>
      <SPie value={value} color={color}>
        <CountUp end={value} />%
      </SPie>
    </TransitionComponent>
  );
};

export default Pie;

const SPie = styled.div(
  {
    width: 136,
    height: 136,
    position: "relative",
    display: "flex",
    alignItems: "center",
    margin: 4,
    placeContent: "center",
    fontSize: getGelTokens().global.fontSizeHeadingSmall,
    fontWeight: "bold",
    fontFamily: getGelTokens().global.fontFamilySans,
    transitionDelay: 2,
    transitionDuration: 0.3,
    transitionTimingFunction: "ease-in-out",
    transitionProperty: "all",

    "&:before, &:after": {
      content: '""',
      position: "absolute",
      borderRadius: "50%",
    },

    "&:before": {
      inset: 0,
      border: `1px solid ${getGelTokens().global.themeColorBorderDefault}`,
      mask: `radial-gradient(farthest-side,#0000 calc(99% - ${
        getGelTokens().global.sizeBaseX3
      }px),#000 calc(100% - ${getGelTokens().global.sizeBaseX3}px))`,
      WebkitMask: `radial-gradient(farthest-side,#0000 calc(99% - ${
        getGelTokens().global.sizeBaseX3
      }px),#000 calc(100% - ${getGelTokens().global.sizeBaseX3}px))`,
    },

    "&:after": {
      inset: `calc(50% - ${getGelTokens().global.sizeBaseX3}px/2)`,
      background: getGelTokens().global.themeColorInteractive1,
    },
  },

  (props) => ({
    "&:before": {
      background: `radial-gradient(farthest-side,${
        getGelTokens().global.themeColorInteractive1
      } 98%,#0000) top/${getGelTokens().global.sizeBaseX3}px ${
        getGelTokens().global.sizeBaseX3
      }px no-repeat,
          conic-gradient(${getGelTokens().global.themeColorInteractive1} calc(${
        props.value
      }*1%),#0000 0)`,
    },
    "&:after": {
      transform: `rotate(calc(${props.value}
         *3.6deg)) translateY(calc(50% - 136px/2))`,
    },

    color: props.color ? props.color : getGelTokens().global.themeColorTextDark,
  })
);
